import * as React from 'react'
import { Status } from '../models';

interface Props {
  status: Status
}

export const StatusIcon = React.memo((props: Props) => {
  switch(props.status) {
    case Status.PRE:
      return <span>&#128993;</span>
    case Status.LIVE:
      return <span>&#128994; LIVE</span>
    case Status.POST:
      return <span>&#9899;</span>
    default:
      return <span>unknown</span>
  }
})
